/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AppIndexRouteImport } from "./routes/_app.index"
import { Route as LoginResetRouteImport } from "./routes/login.reset"
import { Route as AppWorkOrdersRouteImport } from "./routes/_app.work-orders"
import { Route as AppTeamUsersRouteImport } from "./routes/_app.team-users"
import { Route as AppSettingsRouteImport } from "./routes/_app.settings"
import { Route as AppRequestsRouteImport } from "./routes/_app.requests"
import { Route as AppProfileRouteImport } from "./routes/_app.profile"
import { Route as AppProceduresRouteImport } from "./routes/_app.procedures"
import { Route as AppDocumentsRouteImport } from "./routes/_app.documents"
import { Route as AppAssetTreeRouteImport } from "./routes/_app.asset-tree"
import { Route as AppWorkOrdersIndexRouteImport } from "./routes/_app.work-orders.index"
import { Route as AppSettingsIndexRouteImport } from "./routes/_app.settings.index"
import { Route as AppProceduresIndexRouteImport } from "./routes/_app.procedures.index"
import { Route as AppDocumentsIndexRouteImport } from "./routes/_app.documents.index"
import { Route as AppAssetsIndexRouteImport } from "./routes/_app.assets.index"
import { Route as AppWorkOrdersWorkOrderIdRouteImport } from "./routes/_app.work-orders.$workOrderId"
import { Route as AppSettingsGeneralRouteImport } from "./routes/_app.settings.general"
import { Route as AppRequestsWorkRequestIdRouteImport } from "./routes/_app.requests.$workRequestId"
import { Route as AppProceduresBuilderRouteImport } from "./routes/_app.procedures.builder"
import { Route as AppProceduresAuthoringRouteImport } from "./routes/_app.procedures.authoring"
import { Route as AppProceduresProcedureIdRouteImport } from "./routes/_app.procedures.$procedureId"
import { Route as AppAssetsAssetIdRouteImport } from "./routes/_app.assets.$assetId"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const LoginResetRoute = LoginResetRouteImport.update({
  id: "/login/reset",
  path: "/login/reset",
  getParentRoute: () => rootRouteImport,
} as any)
const AppWorkOrdersRoute = AppWorkOrdersRouteImport.update({
  id: "/work-orders",
  path: "/work-orders",
  getParentRoute: () => AppRoute,
} as any)
const AppTeamUsersRoute = AppTeamUsersRouteImport.update({
  id: "/team-users",
  path: "/team-users",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsRoute = AppRequestsRouteImport.update({
  id: "/requests",
  path: "/requests",
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AppRoute,
} as any)
const AppProceduresRoute = AppProceduresRouteImport.update({
  id: "/procedures",
  path: "/procedures",
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRoute = AppDocumentsRouteImport.update({
  id: "/documents",
  path: "/documents",
  getParentRoute: () => AppRoute,
} as any)
const AppAssetTreeRoute = AppAssetTreeRouteImport.update({
  id: "/asset-tree",
  path: "/asset-tree",
  getParentRoute: () => AppRoute,
} as any)
const AppWorkOrdersIndexRoute = AppWorkOrdersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppWorkOrdersRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppProceduresIndexRoute = AppProceduresIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppProceduresRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppDocumentsRoute,
} as any)
const AppAssetsIndexRoute = AppAssetsIndexRouteImport.update({
  id: "/assets/",
  path: "/assets/",
  getParentRoute: () => AppRoute,
} as any)
const AppWorkOrdersWorkOrderIdRoute =
  AppWorkOrdersWorkOrderIdRouteImport.update({
    id: "/$workOrderId",
    path: "/$workOrderId",
    getParentRoute: () => AppWorkOrdersRoute,
  } as any)
const AppSettingsGeneralRoute = AppSettingsGeneralRouteImport.update({
  id: "/general",
  path: "/general",
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppRequestsWorkRequestIdRoute =
  AppRequestsWorkRequestIdRouteImport.update({
    id: "/$workRequestId",
    path: "/$workRequestId",
    getParentRoute: () => AppRequestsRoute,
  } as any)
const AppProceduresBuilderRoute = AppProceduresBuilderRouteImport.update({
  id: "/builder",
  path: "/builder",
  getParentRoute: () => AppProceduresRoute,
} as any)
const AppProceduresAuthoringRoute = AppProceduresAuthoringRouteImport.update({
  id: "/authoring",
  path: "/authoring",
  getParentRoute: () => AppProceduresRoute,
} as any)
const AppProceduresProcedureIdRoute =
  AppProceduresProcedureIdRouteImport.update({
    id: "/$procedureId",
    path: "/$procedureId",
    getParentRoute: () => AppProceduresRoute,
  } as any)
const AppAssetsAssetIdRoute = AppAssetsAssetIdRouteImport.update({
  id: "/assets/$assetId",
  path: "/assets/$assetId",
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  "/asset-tree": typeof AppAssetTreeRoute
  "/documents": typeof AppDocumentsRouteWithChildren
  "/procedures": typeof AppProceduresRouteWithChildren
  "/profile": typeof AppProfileRoute
  "/requests": typeof AppRequestsRouteWithChildren
  "/settings": typeof AppSettingsRouteWithChildren
  "/team-users": typeof AppTeamUsersRoute
  "/work-orders": typeof AppWorkOrdersRouteWithChildren
  "/login/reset": typeof LoginResetRoute
  "/": typeof AppIndexRoute
  "/assets/$assetId": typeof AppAssetsAssetIdRoute
  "/procedures/$procedureId": typeof AppProceduresProcedureIdRoute
  "/procedures/authoring": typeof AppProceduresAuthoringRoute
  "/procedures/builder": typeof AppProceduresBuilderRoute
  "/requests/$workRequestId": typeof AppRequestsWorkRequestIdRoute
  "/settings/general": typeof AppSettingsGeneralRoute
  "/work-orders/$workOrderId": typeof AppWorkOrdersWorkOrderIdRoute
  "/assets": typeof AppAssetsIndexRoute
  "/documents/": typeof AppDocumentsIndexRoute
  "/procedures/": typeof AppProceduresIndexRoute
  "/settings/": typeof AppSettingsIndexRoute
  "/work-orders/": typeof AppWorkOrdersIndexRoute
}
export interface FileRoutesByTo {
  "/asset-tree": typeof AppAssetTreeRoute
  "/profile": typeof AppProfileRoute
  "/requests": typeof AppRequestsRouteWithChildren
  "/team-users": typeof AppTeamUsersRoute
  "/login/reset": typeof LoginResetRoute
  "/": typeof AppIndexRoute
  "/assets/$assetId": typeof AppAssetsAssetIdRoute
  "/procedures/$procedureId": typeof AppProceduresProcedureIdRoute
  "/procedures/authoring": typeof AppProceduresAuthoringRoute
  "/procedures/builder": typeof AppProceduresBuilderRoute
  "/requests/$workRequestId": typeof AppRequestsWorkRequestIdRoute
  "/settings/general": typeof AppSettingsGeneralRoute
  "/work-orders/$workOrderId": typeof AppWorkOrdersWorkOrderIdRoute
  "/assets": typeof AppAssetsIndexRoute
  "/documents": typeof AppDocumentsIndexRoute
  "/procedures": typeof AppProceduresIndexRoute
  "/settings": typeof AppSettingsIndexRoute
  "/work-orders": typeof AppWorkOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/_app/asset-tree": typeof AppAssetTreeRoute
  "/_app/documents": typeof AppDocumentsRouteWithChildren
  "/_app/procedures": typeof AppProceduresRouteWithChildren
  "/_app/profile": typeof AppProfileRoute
  "/_app/requests": typeof AppRequestsRouteWithChildren
  "/_app/settings": typeof AppSettingsRouteWithChildren
  "/_app/team-users": typeof AppTeamUsersRoute
  "/_app/work-orders": typeof AppWorkOrdersRouteWithChildren
  "/login/reset": typeof LoginResetRoute
  "/_app/": typeof AppIndexRoute
  "/_app/assets/$assetId": typeof AppAssetsAssetIdRoute
  "/_app/procedures/$procedureId": typeof AppProceduresProcedureIdRoute
  "/_app/procedures/authoring": typeof AppProceduresAuthoringRoute
  "/_app/procedures/builder": typeof AppProceduresBuilderRoute
  "/_app/requests/$workRequestId": typeof AppRequestsWorkRequestIdRoute
  "/_app/settings/general": typeof AppSettingsGeneralRoute
  "/_app/work-orders/$workOrderId": typeof AppWorkOrdersWorkOrderIdRoute
  "/_app/assets/": typeof AppAssetsIndexRoute
  "/_app/documents/": typeof AppDocumentsIndexRoute
  "/_app/procedures/": typeof AppProceduresIndexRoute
  "/_app/settings/": typeof AppSettingsIndexRoute
  "/_app/work-orders/": typeof AppWorkOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/asset-tree"
    | "/documents"
    | "/procedures"
    | "/profile"
    | "/requests"
    | "/settings"
    | "/team-users"
    | "/work-orders"
    | "/login/reset"
    | "/"
    | "/assets/$assetId"
    | "/procedures/$procedureId"
    | "/procedures/authoring"
    | "/procedures/builder"
    | "/requests/$workRequestId"
    | "/settings/general"
    | "/work-orders/$workOrderId"
    | "/assets"
    | "/documents/"
    | "/procedures/"
    | "/settings/"
    | "/work-orders/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/asset-tree"
    | "/profile"
    | "/requests"
    | "/team-users"
    | "/login/reset"
    | "/"
    | "/assets/$assetId"
    | "/procedures/$procedureId"
    | "/procedures/authoring"
    | "/procedures/builder"
    | "/requests/$workRequestId"
    | "/settings/general"
    | "/work-orders/$workOrderId"
    | "/assets"
    | "/documents"
    | "/procedures"
    | "/settings"
    | "/work-orders"
  id:
    | "__root__"
    | "/_app"
    | "/_app/asset-tree"
    | "/_app/documents"
    | "/_app/procedures"
    | "/_app/profile"
    | "/_app/requests"
    | "/_app/settings"
    | "/_app/team-users"
    | "/_app/work-orders"
    | "/login/reset"
    | "/_app/"
    | "/_app/assets/$assetId"
    | "/_app/procedures/$procedureId"
    | "/_app/procedures/authoring"
    | "/_app/procedures/builder"
    | "/_app/requests/$workRequestId"
    | "/_app/settings/general"
    | "/_app/work-orders/$workOrderId"
    | "/_app/assets/"
    | "/_app/documents/"
    | "/_app/procedures/"
    | "/_app/settings/"
    | "/_app/work-orders/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginResetRoute: typeof LoginResetRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/login/reset": {
      id: "/login/reset"
      path: "/login/reset"
      fullPath: "/login/reset"
      preLoaderRoute: typeof LoginResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/work-orders": {
      id: "/_app/work-orders"
      path: "/work-orders"
      fullPath: "/work-orders"
      preLoaderRoute: typeof AppWorkOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/team-users": {
      id: "/_app/team-users"
      path: "/team-users"
      fullPath: "/team-users"
      preLoaderRoute: typeof AppTeamUsersRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings": {
      id: "/_app/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/requests": {
      id: "/_app/requests"
      path: "/requests"
      fullPath: "/requests"
      preLoaderRoute: typeof AppRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/profile": {
      id: "/_app/profile"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/procedures": {
      id: "/_app/procedures"
      path: "/procedures"
      fullPath: "/procedures"
      preLoaderRoute: typeof AppProceduresRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/documents": {
      id: "/_app/documents"
      path: "/documents"
      fullPath: "/documents"
      preLoaderRoute: typeof AppDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/asset-tree": {
      id: "/_app/asset-tree"
      path: "/asset-tree"
      fullPath: "/asset-tree"
      preLoaderRoute: typeof AppAssetTreeRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/work-orders/": {
      id: "/_app/work-orders/"
      path: "/"
      fullPath: "/work-orders/"
      preLoaderRoute: typeof AppWorkOrdersIndexRouteImport
      parentRoute: typeof AppWorkOrdersRoute
    }
    "/_app/settings/": {
      id: "/_app/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    "/_app/procedures/": {
      id: "/_app/procedures/"
      path: "/"
      fullPath: "/procedures/"
      preLoaderRoute: typeof AppProceduresIndexRouteImport
      parentRoute: typeof AppProceduresRoute
    }
    "/_app/documents/": {
      id: "/_app/documents/"
      path: "/"
      fullPath: "/documents/"
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppDocumentsRoute
    }
    "/_app/assets/": {
      id: "/_app/assets/"
      path: "/assets"
      fullPath: "/assets"
      preLoaderRoute: typeof AppAssetsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/work-orders/$workOrderId": {
      id: "/_app/work-orders/$workOrderId"
      path: "/$workOrderId"
      fullPath: "/work-orders/$workOrderId"
      preLoaderRoute: typeof AppWorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof AppWorkOrdersRoute
    }
    "/_app/settings/general": {
      id: "/_app/settings/general"
      path: "/general"
      fullPath: "/settings/general"
      preLoaderRoute: typeof AppSettingsGeneralRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    "/_app/requests/$workRequestId": {
      id: "/_app/requests/$workRequestId"
      path: "/$workRequestId"
      fullPath: "/requests/$workRequestId"
      preLoaderRoute: typeof AppRequestsWorkRequestIdRouteImport
      parentRoute: typeof AppRequestsRoute
    }
    "/_app/procedures/builder": {
      id: "/_app/procedures/builder"
      path: "/builder"
      fullPath: "/procedures/builder"
      preLoaderRoute: typeof AppProceduresBuilderRouteImport
      parentRoute: typeof AppProceduresRoute
    }
    "/_app/procedures/authoring": {
      id: "/_app/procedures/authoring"
      path: "/authoring"
      fullPath: "/procedures/authoring"
      preLoaderRoute: typeof AppProceduresAuthoringRouteImport
      parentRoute: typeof AppProceduresRoute
    }
    "/_app/procedures/$procedureId": {
      id: "/_app/procedures/$procedureId"
      path: "/$procedureId"
      fullPath: "/procedures/$procedureId"
      preLoaderRoute: typeof AppProceduresProcedureIdRouteImport
      parentRoute: typeof AppProceduresRoute
    }
    "/_app/assets/$assetId": {
      id: "/_app/assets/$assetId"
      path: "/assets/$assetId"
      fullPath: "/assets/$assetId"
      preLoaderRoute: typeof AppAssetsAssetIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppDocumentsRouteChildren {
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
}

const AppDocumentsRouteChildren: AppDocumentsRouteChildren = {
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
}

const AppDocumentsRouteWithChildren = AppDocumentsRoute._addFileChildren(
  AppDocumentsRouteChildren,
)

interface AppProceduresRouteChildren {
  AppProceduresProcedureIdRoute: typeof AppProceduresProcedureIdRoute
  AppProceduresAuthoringRoute: typeof AppProceduresAuthoringRoute
  AppProceduresBuilderRoute: typeof AppProceduresBuilderRoute
  AppProceduresIndexRoute: typeof AppProceduresIndexRoute
}

const AppProceduresRouteChildren: AppProceduresRouteChildren = {
  AppProceduresProcedureIdRoute: AppProceduresProcedureIdRoute,
  AppProceduresAuthoringRoute: AppProceduresAuthoringRoute,
  AppProceduresBuilderRoute: AppProceduresBuilderRoute,
  AppProceduresIndexRoute: AppProceduresIndexRoute,
}

const AppProceduresRouteWithChildren = AppProceduresRoute._addFileChildren(
  AppProceduresRouteChildren,
)

interface AppRequestsRouteChildren {
  AppRequestsWorkRequestIdRoute: typeof AppRequestsWorkRequestIdRoute
}

const AppRequestsRouteChildren: AppRequestsRouteChildren = {
  AppRequestsWorkRequestIdRoute: AppRequestsWorkRequestIdRoute,
}

const AppRequestsRouteWithChildren = AppRequestsRoute._addFileChildren(
  AppRequestsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsGeneralRoute: typeof AppSettingsGeneralRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsGeneralRoute: AppSettingsGeneralRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppWorkOrdersRouteChildren {
  AppWorkOrdersWorkOrderIdRoute: typeof AppWorkOrdersWorkOrderIdRoute
  AppWorkOrdersIndexRoute: typeof AppWorkOrdersIndexRoute
}

const AppWorkOrdersRouteChildren: AppWorkOrdersRouteChildren = {
  AppWorkOrdersWorkOrderIdRoute: AppWorkOrdersWorkOrderIdRoute,
  AppWorkOrdersIndexRoute: AppWorkOrdersIndexRoute,
}

const AppWorkOrdersRouteWithChildren = AppWorkOrdersRoute._addFileChildren(
  AppWorkOrdersRouteChildren,
)

interface AppRouteChildren {
  AppAssetTreeRoute: typeof AppAssetTreeRoute
  AppDocumentsRoute: typeof AppDocumentsRouteWithChildren
  AppProceduresRoute: typeof AppProceduresRouteWithChildren
  AppProfileRoute: typeof AppProfileRoute
  AppRequestsRoute: typeof AppRequestsRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTeamUsersRoute: typeof AppTeamUsersRoute
  AppWorkOrdersRoute: typeof AppWorkOrdersRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppAssetsAssetIdRoute: typeof AppAssetsAssetIdRoute
  AppAssetsIndexRoute: typeof AppAssetsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAssetTreeRoute: AppAssetTreeRoute,
  AppDocumentsRoute: AppDocumentsRouteWithChildren,
  AppProceduresRoute: AppProceduresRouteWithChildren,
  AppProfileRoute: AppProfileRoute,
  AppRequestsRoute: AppRequestsRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTeamUsersRoute: AppTeamUsersRoute,
  AppWorkOrdersRoute: AppWorkOrdersRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppAssetsAssetIdRoute: AppAssetsAssetIdRoute,
  AppAssetsIndexRoute: AppAssetsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginResetRoute: LoginResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
